export const publicUrl = `${window.location.protocol}//${window.location.host}`;

export const formCodeTemplate = `
<div id="$formId"></div>
<script charset="utf-8" type="application/javascript" src="${publicUrl}/applicant-form/main.js"></script>
<script charset="utf-8" type="application/javascript" src="${publicUrl}/applicant-form/form-data.js"></script>
`;
